(function () {
    'use strict';

    angular.module("imApp").factory("oeeStatesService", ['$ihttp', function ($ihttp) {
        let service = {
            listOeeStates: function (parms) {
                return $ihttp.post({
                    method: 240,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
